module.exports = __webpack_public_path__ + "static/img/B1电动方向盘.6929011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD200/B1电动方向盘.png
// module id = sozr
// module chunks = 0